export function formatDateTime(dateString) {
    if(!dateString) return ""; // Handle empty or undefined dateString
    const date = new Date(dateString);
    
    // Get day, month, year
    const day = date.getDate();
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    
    // Get time with AM/PM
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // Convert 0 to 12
    
    // Combine all parts
    //return `${day} ${month} ${year} ${hours}:${minutes}${ampm}`;
    return `${day} ${month} ${year} `;
  }